import React from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { deliveryErrorMessageKey } from './deliveryStatusPresentation'

/**
 * Story 175, S135 (RN56, GATE 2) -- the details list failed because of what it asked about DELIVERY (a
 * status filter and/or a delivery sort key): the translated literal of Sun's `code`, and the way out of
 * what was asked -- "Clear filter" if a filter was sent, "Clear sort" if a delivery sort was sent.
 */
const DeliveryListError = ({ listError, onClearFilter, onClearSort }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Alert
      severity='error'
      variant='outlined'
      sx={{ marginBottom: 1 }}
      data-testid='delivery-list-error'
      action={(
        <>
          {listError.filter ? <Button color='inherit' size='small' onClick={onClearFilter}>{t_('Clear filter')}</Button> : null}
          {listError.sort ? <Button color='inherit' size='small' onClick={onClearSort}>{t_('Clear sort')}</Button> : null}
        </>
      )}
    >
      {t_(deliveryErrorMessageKey(listError.error))}
    </Alert>
  )
}

export default DeliveryListError
